import { ComponentProps, FC, ReactNode } from 'react'
import { cn } from '../utils'

type Props = {
  icon?: FC<{ className?: string }>
  title?: ReactNode
  description?: ReactNode
  primaryAction?: ReactNode
  secondaryAction?: ReactNode
  iconSize?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  descriptionSize?: '1' | '2'
  className?: string
} & Pick<ComponentProps<'div'>, 'style'>

const iconSizeClasses = {
  1: 'h-4 w-4',
  2: 'h-8 w-8',
  3: 'h-12 w-12',
  4: 'h-16 w-16',
  5: 'h-20 w-20',
  6: 'h-24 w-24',
  7: 'h-28 w-28',
  8: 'h-32 w-32',
  9: 'h-36 w-36',
  10: 'h-40 w-40',
}

const descriptionSizeClasses = {
  '1': 'text-xs',
  '2': 'text-sm',
}

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  primaryAction,
  secondaryAction,
  iconSize = 4,
  descriptionSize = '2',
  className,
  ...props
}: Props) => {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-5', className)} {...props}>
      {Icon && (
        <div className={cn('flex items-center justify-center', iconSizeClasses[iconSize])}>
          <Icon className="h-full w-full" />
        </div>
      )}
      {title && <h3 className="text-center text-sm font-medium text-foreground">{title}</h3>}
      {description && (
        <p
          className={cn(
            'text-center text-sm font-normal text-muted-foreground',
            descriptionSizeClasses[descriptionSize]
          )}
        >
          {description}
        </p>
      )}
      {primaryAction}
      {secondaryAction}
    </div>
  )
}
